import React from 'react';
import PropTypes from 'prop-types';
import { useClassName } from 'common/hooks';
import HomepageAsset from 'public/screens/Home/Components/Asset';

import './styles/hero-section.less';

const HeroSection = ({ blueprint }) => {
  const className = useClassName('HeroSection');

  if (!blueprint) return null;

  return (
    <div className={className('container')}>
      <HomepageAsset
        asset={blueprint.asset}
        poster={null}
        className={className('media')}
        style={{ opacity: 1 }}
      />
    </div>
  );
};

HeroSection.propTypes = {
  blueprint: PropTypes.object,
};

export default HeroSection;
